import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.alert.corner', {
      wrapper: {
        width: 440,
        p: 16,
        borderRadius: 'control',
        boxShadow: composeStyle.switch('variant')
          .case('card', 'level3'),
        bg: composeStyle.switch('variant')
          .case('default', composeStyle.switch('modifier')
            .case('info', 'palette.tinBlue.base')
            .case('success', 'palette.tinGreen.base')
            .case('warn', 'palette.tinYellow.base')
            .case('error', 'palette.tinRed.base'))
          .case('card', 'card'),
        'cmp.alert.base.common': 'icon',
      },
      title: {
        mb: 8,
        fontWeight: 'medium',
        lineHeight: '24px',
        fontSize: '14px',
      },
      content: {
        color: 'mute',
        ml: 26,
        mr: '2x',
        mb: composeStyle.when('clickDetail')
          .truthy('x')
          .falsy('3xs'),
        lineHeight: '22px',
        fontSize: '14px',
      },
    }),

    registerThemeSpec('cmp.alert.base', {
      common: {
        icon: {
          '[data-icon="cross"]': {
            fill: '#979797',
            '&:hover': {
              fill: 'palette.mute.hover',
            },
          },
          '[data-icon="type"]': {
            fill: composeStyle.switch('modifier')
              .case('info', 'brand')
              .case('success', 'success')
              .case('warn', 'warn')
              .case('error', 'error'),
          },
        },
        wrapper: {
          inline: {
            bg: composeStyle.switch('modifier')
              .case('info', 'palette.tinBlue.base')
              .case('success', 'palette.tinGreen.base')
              .case('warn', 'palette.tinYellow.base')
              .case('error', 'palette.tinRed.base'),
            color: 'body',
          },
          global: {
            boxShadow: 'level3',
            bg: 'card',
            color: composeStyle.switch('modifier')
              .case('error', 'error')
              .default('body'),
          },
        },
      },
      wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: '9px 16px',
        fontSize: 14,
        lineHeight: '22px',
        borderRadius: 'control',
        'cmp.alert.base.common': 'icon',
        'cmp.alert.base.common.wrapper': composeStyle.var('variant', '_VAR_'),
      },
      globalTitle: {
        maxWidth: 280,
      },
      inlineTitle: {
      },
    }),
  ]
}
